import {CommentListOrdering, DeletedCommentBody} from 'types/comments';

export const applyCommentListConfig = (comments: UserComment[], config: CommentListConfig) => {
  return removeDeleted(comments).sort((c1, c2) => {
    if (c1.new_comment) {
      return -1;
    }
    if (c2.new_comment) {
      return 1;
    }
    if (c1.top_comment) {
      return -1;
    }
    if (c2.top_comment) {
      return 1;
    }
    if (config.ordering === CommentListOrdering.Rating) {
      return c2.upvotes - c1.upvotes;
    }
    if (config.ordering === CommentListOrdering.Recent) {
      return c1.created_at <= c2.created_at ? 1 : -1;
    }
    if (config.ordering === CommentListOrdering.Trending) {
      return c1.trending_score <= c2.trending_score ? 1 : -1;
    }
  });
};

export const defaultCommentListConfig: CommentListConfig = {
  ordering: CommentListOrdering.Trending,
};

export const orderingOptions = [
  {value: CommentListOrdering.Trending, label: 'Trending'},
  {value: CommentListOrdering.Rating, label: 'Top rated'},
  {value: CommentListOrdering.Recent, label: 'Recently commented'},
];

// TODO: Should this be filtered out in the backend?
const removeDeleted = (comments: UserComment[]): UserComment[] =>
  comments
    .filter((comment) => comment.body !== DeletedCommentBody)
    .map((comment) => ({...comment, children: removeDeleted(comment.children)}));

// Helper function to add a comment anywhere in the tree (path is an array of ids).
export const addNested = (comments: UserComment[], path: number[], newComment: UserComment) => {
  if (path.length === 0) return [...comments, newComment];
  const [id, ...remainingPath] = path;
  return comments.map((comment) => {
    if (comment.id !== id) return comment;
    return {
      ...comment,
      children: addNested(comment.children, remainingPath, newComment),
    };
  });
};

// Helper function to replace a comment anywhere in the tree (path is an array of ids).
export const replaceNested = (comments: UserComment[], path: number[], newComment: UserComment) => {
  const [id, ...remainingPath] = path;
  return comments.map((comment) => {
    if (comment.id !== id) return comment;
    return remainingPath.length === 0
      ? newComment
      : {
          ...comment,
          children: replaceNested(comment.children, remainingPath, newComment),
        };
  });
};
